import { Header, Hero, Section } from '@components';
import { motion } from 'motion/react';
import React from 'react';

const Highlights = ({ header, slides, img, video }) => {
  return (
    <Section>
      {header && (
        <Header
          label={header?.label}
          title={header?.title}
          description={header?.description}
          cta={null}
          className={' pt-16 md:pt-0 md:mt-0'}
        />
      )}
      <motion.div
        initial={{ opacity: 0.5 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 2 }}
      >
        <Hero
          isBanner={true}
          hasSlider={slides?.length > 0}
          slides={slides}
          img={img}
          {...header}
        />
      </motion.div>
    </Section>
  );
};

export default Highlights;
